import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { AICreateCustomBookingMethodsRequest, CustomBookingMethod, TestCustomBookingMethodsRequest } from '~api/som';

import { IgnoredError } from '~src/errors/IgnoredError';
import { SomApiInstance } from '~src/main/api';
import { useShippingMethodQueryKey } from '~src/main/queries';

import { useBookingRuleQueryKey } from './queries';

export function useBookingRuleSaveMutation() {
  const shippingMethodKeys = useShippingMethodQueryKey();
  const keys = useBookingRuleQueryKey();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CustomBookingMethod[]) => {
      try {
        await SomApiInstance.customBookingMethodsPublish.somPublishCustomBookingMethods({
          custom_booking_methods: payload,
        });
      } catch (e) {
        // don't report validation errors
        if (isAxiosError(e) && e.response?.status === 400) {
          throw new IgnoredError('failed to update custom booking methods due to validation error');
        }

        throw e;
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: shippingMethodKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}

export function useBookingRuleTestMutation() {
  return useMutation({
    mutationFn: (payload: TestCustomBookingMethodsRequest) =>
      SomApiInstance.customBookingMethodsTest.somTestCustomBookingMethods(payload, {
        timeout: 5 * 60 * 1000, // 5 minutes
      }),
  });
}

export function useBookingRulePromptMutation() {
  return useMutation({
    mutationFn: (payload: AICreateCustomBookingMethodsRequest) =>
      SomApiInstance.customBookingMethodsPrompt.somAiCreateCustomBookingMethods(payload, {
        timeout: 5 * 60 * 1000, // 5 minutes
      }),
  });
}
